import React, { useState, useEffect } from 'react';
import Chat from './Chat';

// Demo mode - automatically log in without credentials
const DEMO_MODE = true;

function App() {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // In demo mode, auto-login on startup
    if (DEMO_MODE) {
      autoLogin();
    } else {
      setLoading(false);
    }
  }, []);

  const autoLogin = async () => {
    try {
      const res = await fetch((process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000') + '/api/v1/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: 'demo@example.com', password: 'demo' })
      });
      if (res.ok) {
        const data = await res.json();
        setToken(data.access_token);
      } else {
        // Even if login fails in demo mode, proceed without token
        setToken('demo-token');
      }
    } catch (err) {
      // Proceed without token in demo mode
      setToken('demo-token');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading Nimble AI Chat...</p>
      </div>
    );
  }

  if (!token && !DEMO_MODE) {
    return <Login onLogin={setToken} />;
  }

  return <Chat token={token} onLogout={() => DEMO_MODE ? null : setToken(null)} />;
}

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch((process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000') + '/api/v1/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      if (!res.ok) throw new Error('Login failed');
      const data = await res.json();
      onLogin(data.access_token);
    } catch (err) {
      setError('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h2>Nimble AI Chat</h2>
      <form onSubmit={handleSubmit}>
        <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
        <button type="submit" disabled={loading}>{loading ? 'Logging in...' : 'Login'}</button>
        {error && <div className="error">{error}</div>}
      </form>
    </div>
  );
}

export default App;
